/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getAccountsByAccountHolderInternal} from '../api'

 export const useQueryGetAccountsByAccountHolderInternal = createReactQueryHook('getAccountsByAccountHolderInternal', getAccountsByAccountHolderInternal)
